import type { PropsWithChildren } from 'react';

import { Container } from '../layout/container';
import { SectionHeading } from './section-heading';

interface PageHeroProps extends PropsWithChildren {
  title: string;
  text?: string;
}

export function PageHero({ title, text, children }: PageHeroProps): JSX.Element {
  return (
    <section className="relative overflow-hidden py-12 sm:py-16">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_10%_0%,var(--color-primary-soft),transparent_45%)]" />
      <Container className="relative space-y-6">
        <SectionHeading title={title} description={text} />
        {children}
      </Container>
    </section>
  );
}
